export default __webpack_public_path__ + "static/media/android.8405c2a6.png";